export default "__VITE_ASSET__CIudIMQ$__"